import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../app/commonReducer';

const TradingViewUrl = ({
  code,
  locale,
  theme,
  listOrganizationByOrganCode,
}) => {
  const params = new URLSearchParams();
  const ticker =
    listOrganizationByOrganCode[code] &&
    listOrganizationByOrganCode[code].ticker
      ? listOrganizationByOrganCode[code].ticker
      : code;
  params.append('code', ticker);
  params.append('lang', locale);
  params.append('theme', theme);
  const url = `/charting?${params.toString()}`;
  return (
    <a
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        window.parent.postMessage(
          {
            action: 'OPEN_CHART',
            data: {
              ticker: ticker,
              language: locale,
              theme: theme,
            },
          },
          '*',
        );
      }}
      className="trading-view-url"
      href={url}
      rel="noopener noreferrer"
      target="_blank"
    >
      <i className="icon-graph fs-10" />
    </a>
  );
};

TradingViewUrl.propTypes = {
  code: PropTypes.string,
  theme: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  listOrganizationByOrganCode: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  theme: state.theme,
  locale: state.i18n.locale,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
});

export default connect(mapStateToProps)(TradingViewUrl);
